import { useEffect } from 'react';

type Callback = (value: string | null) => void;

export const useLocalStorageWatcher = (key: string, callback: Callback) => {
  useEffect(() => {
    const handleStorage = (event: StorageEvent) => {
      if (event.key === key) {
        callback(event.newValue);
      }
    };

    const handleCustomStorage = (event: Event) => {
      const customEvent = event as CustomEvent<{ key: string; value: string }>;
      if (customEvent.detail.key === key) {
        callback(customEvent.detail.value);
      }
    };

    window.addEventListener('storage', handleStorage);
    window.addEventListener('local-storage-change', handleCustomStorage);

    return () => {
      window.removeEventListener('storage', handleStorage);
      window.removeEventListener('local-storage-change', handleCustomStorage);
    };
  }, [key, callback]);
};

export const setLocalStorageItem = (key: string, value: string) => {
    localStorage.setItem(key, value);
    window.dispatchEvent(
    new CustomEvent('local-storage-change', {
        detail: { key, value },
    })
    );
};